export const statusEnums = [
	{
		id: 1,
		name: "Online",
		value: 1,
	},
	{
		id: 0,
		name: "Offline",
		value: 0,
	},
];
